export default class AuthService{
  constructor(server, $state, Idle){
    this.server = server;
    this.user = null;
    this.idle = Idle;
    this.nextState = null;
    this.$state = $state;
    this.timeToLogout = null;
    this.inactivityLogout = false;
    this.timer = setInterval(() => {
      if(this.timeToLogout != null) {
        if(this.timeToLogout > 0) {
          this.timeToLogout--;
        }
      }
      }, 1000);
  }

  get isLoggedIn(){
    return this.user !== null;
  }

  autologin(){
    return this.server("auth.getUser").then(user => this.session(user));
  }

  keepalive(){
    return this.server("auth.getUser").then(user => user, err => null).then(user => {
      if(!user){
        this.user = null;
        this.$state.go("login");
      }else if(!this.user){
        this.session(user);
      }
    });
  }

  login(email, password){
    this.idle.watch();
    this.setInactivityLogout(false);
    return this.server("auth.login", {email: email, password: password}).then(user => this.session(user));
  }

  tokenLogin(token){
    return this.server('auth.login.token',{token: token}).then(user=>this.session(user));
  }

  logout(){
    this.$state.go("login");
    this.server("auth.logout").then(() => this.session(null));
  }

  hasRole(roleId){
    if(this.user && this.user.role){
      return !!this.user.role.find(role => role.id == roleId);
    }
    return false;
  }

  can(permission){
    if(this.user && this.user.permissions){
      return !!this.user.permissions.find(p => p === permission);
    }
    return false;
  }

  resume(){
    if(this.nextState && this.nextState.name() != "login"){
      this.$state.go(this.nextState.name(), this.nextState.params());
    }else{
      this.$state.go("home");
    }
    this.nextState = null;
  }

  /* starts user session */
  session(user){
    if(user){
      this.user = user;
    }else{
      this.user = null;
    }
    this.resume();
    return user;
  }

  stopTimer() {
    this.timeToLogout = null;
  }

  resetTimer(timeout) {
    this.timeToLogout = timeout;
  }

  canShowTimeToLogoutPanel() {
    return this.timeToLogout !== null;
  }

  getTimeToLogout() {
    return new Date(this.timeToLogout * 1000).toISOString().substring(14, 19);
  }

  setInactivityLogout(inactivity) {
    this.inactivityLogout = inactivity;
  }

  getInactivityLogout() {
    return this.inactivityLogout;
  }
}


// WEBPACK FOOTER //
// ./src/Auth/AuthService.js